import React from 'react';
import PropTypes from 'prop-types';
import NavItem from '../../../common/ui/NavItem';

export const ManageWebsiteActions = ({ slug, published, pageKey, publishWebsite }) => (
  <div className="manage-website-actions__container">
    {
      !published && (
        <ul className="nav navbar-nav navbar-right manage-website-actions__not-visible">
          <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
            <button type="button" className="btn btn-secondary navbar-btn preview-website__btn">Preview<span className="hidden-xs"> Website</span></button>
          </NavItem>
          <NavItem to="" activeClassName="active">
            <button type="button" className="btn btn-danger navbar-btn make-website-visible__btn" onClick={() => publishWebsite()}>Make Website Visible</button>
          </NavItem>
        </ul>
      )
    }
    {
      published && (
        <ul className="nav navbar-nav navbar-right">
          <a className="manage-website-actions__settings" href="/account/settings/privacy" target="_blank" rel="noopener noreferrer">
            <button type="button" className="btn btn-secondary navbar-btn hidden-sm hidden-xs view-settings__btn">View Settings</button>
            <button type="button" className="btn btn-secondary navbar-btn visible-sm visible-xs view-settings__btn-sm">Settings</button>
          </a>
          <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
            <button type="button" className="btn btn-primary navbar-btn view-website__btn" >View Website</button>
          </NavItem>
        </ul>
      )
    }
  </div>
);

ManageWebsiteActions.propTypes = {
  slug: PropTypes.string,
  published: PropTypes.bool,
  publishWebsite: PropTypes.func,
  pageKey: PropTypes.string
};


// V2 HANDLING CMS CUSTOMIZATION REDESIGN

export const ManageWebsiteActionsV2 = ({ slug, published, pageKey, publishWebsite }) => (
  <div className="manage-website-actions__container">
    {
      !published && (
        <div className="website-actions-container">
          <ul className="nav navbar-nav navbar-left manage-website-actions__not-visible">
            <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
              <div className="navbar-btn text-button"><span className="zolaicon zolaicon-visible" />Preview<span className="hidden-xs"> Website</span></div>
            </NavItem>
            <NavItem to="" activeClassName="active">
              <button type="button" className="btn btn-danger navbar-btn make-website-visible__btn" onClick={() => publishWebsite()}>Make Website Visible</button>
            </NavItem>
          </ul>
          <ul className="nav navbar-nav navbar-right manage-website-actions__not-visible">
            <navItem to="">
              <button type="button" className="btn btn-primary navbar-btn">Continue</button>
            </navItem>
          </ul>
        </div>
      )
    }
    {
      published && (
        <div className="website-actions-container">
          <ul className="nav navbar-nav navbar-left">
            <a className="manage-website-actions__settings" href="/account/settings/privacy" target="_blank" rel="noopener noreferrer">
              <div className="navbar-btn hidden-sm hidden-xs text-button"><span className="zolaicon zolaicon-gear" />Privacy Settings</div>
              <div className="visible-xs text-button"><span className="zolaicon zolaicon-gear" />Settings</div>
            </a>
            <NavItem to={`/wedding/${slug}/${!pageKey || pageKey === 'home' ? '' : pageKey}`} activeClassName="active" target="_blank">
              <div className="navbar-btn text-button" ><span className="zolaicon zolaicon-visible" />View Website</div>
            </NavItem>
          </ul>
          <ul className="nav navbar-nav navbar-right manage-website-actions__visible">
            <navItem to="">
              <button type="button" className="btn btn-primary navbar-btn hidden-xs">Continue</button>
            </navItem>
          </ul>
        </div>
      )
    }
  </div>
);

ManageWebsiteActionsV2.propTypes = {
  slug: PropTypes.string,
  published: PropTypes.bool,
  publishWebsite: PropTypes.func,
  pageKey: PropTypes.string
};




/** WEBPACK FOOTER **
 ** ./src/components/manage/website/entities/ManageWebsiteActions.jsx
 **/